import { ParkPayload } from 'services/payloads/ParkPayload';
import { ModelLike, JsonApiPayload } from './JsonApiPayload';

export class RatePayload extends JsonApiPayload {
  id: string;
  pmsId: string;
  parkId: string;
  siteTypeIds: string[];
  discountIds: string[];
  name: string;
  description: string;
  longDescription: string;
  dailyAmount: number;
  weeklyAmount: number;
  monthlyAmount: number;
  yearlyAmount: number;
  mondayAmount: number;
  tuesdayAmount: number;
  wednesdayAmount: number;
  thursdayAmount: number;
  fridayAmount: number;
  saturdayAmount: number;
  sundayAmount: number;
  overwriteDaily: boolean;
  rateChargeDescription: string;
  active: boolean;
  extraGuestFee: number;
  extraPetFee: number;
  includedGuests: number;
  includedPets: number;
  maxGuests: number;
  maxPets: number;
  createdAt: string;
  updatedAt: string;
  // relationships
  park: ParkPayload;
  siteTypes: any[];
  discounts: any[];

  static new(model?: ModelLike) {
    return super.fill(new this(), model);
  }

  static getSchema() {
    return super._getSchema(this, ['park', 'siteTypes', 'discounts']);
  }
}
